var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "157px",
    height: "219px",
    viewBox: "0 0 157 219",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3 copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M98.9227642,155 L98.9227642,143.60735 C99.7737127,137.611219 101.8479,132.614442 105.145325,128.617021 C108.442751,124.6196 112.218835,121.071889 116.473577,117.973888 C120.72832,114.875887 125.248984,111.777885 130.035569,108.679884 C134.822154,105.581883 139.183266,101.8343 143.118902,97.4371373 C147.054539,93.0399742 150.351965,87.7433914 153.011179,81.5473888 C155.670393,75.3513862 157,67.4564797 157,57.8626692 C157,52.0664088 155.670393,45.8204384 153.011179,39.1247582 C150.351965,32.429078 145.937669,26.1831077 139.768293,20.3868472 C133.598916,14.5905867 125.461721,9.74371373 115.356707,5.84622824 C105.251694,1.94874275 92.647019,0 77.5426829,0 C65.8421409,0 55.2584688,1.84880722 45.7916667,5.54642166 C36.3248645,9.24403611 28.2408537,14.3907157 21.5396341,20.9864603 C14.8384146,27.582205 9.62635501,35.377176 5.90345528,44.3713733 C2.18055556,53.3655706 0.212737127,63.2591876 0,74.0522244 L46.9085366,74.0522244 C46.9085366,68.655706 47.546748,63.608962 48.8231707,58.9119923 C50.0995935,54.2150226 52.0674119,50.117666 54.726626,46.6199226 C57.3858401,43.1221792 60.7896341,40.3239845 64.9380081,38.2253385 C69.0863821,36.1266925 74.0325203,35.0773694 79.7764228,35.0773694 C88.2859079,35.0773694 94.9339431,37.275951 99.7205285,41.6731141 C104.507114,46.0702772 106.900407,52.865893 106.900407,62.0599613 C107.113144,67.4564797 106.102642,71.9535783 103.868902,75.5512573 C101.635163,79.1489362 98.7100271,82.4468085 95.0934959,85.4448743 C91.4769648,88.44294 87.5413279,91.4410058 83.2865854,94.4390716 C79.0318428,97.4371373 74.9898374,100.984848 71.1605691,105.082205 C67.3313008,109.179562 63.9806911,114.12637 61.1087398,119.922631 C58.2367886,125.718891 56.4817073,132.914249 55.8434959,141.508704 L55.8434959,155 L98.9227642,155 Z M102,219 L102,173 L52,173 L52,219 L102,219 Z",
    id: "path-question"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mainPage-concepts",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.300000012
  }, /*#__PURE__*/React.createElement("g", {
    id: "Alantm-landingame",
    transform: "translate(-120.000000, -4878.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3,
    transform: "translate(120.000000, 4878.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "question",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-question"
  })), /*#__PURE__*/React.createElement("g", {
    id: "?",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -179,
    y1: -126,
    x2: 85.0029159,
    y2: 346.352281,
    id: "Line-2-Copy",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -169,
    y1: -126,
    x2: 95.0029159,
    y2: 346.352281,
    id: "Line-2-Copy-2",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -159,
    y1: -126,
    x2: 105.002916,
    y2: 346.352281,
    id: "Line-2-Copy-3",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -149,
    y1: -126,
    x2: 115.002916,
    y2: 346.352281,
    id: "Line-2-Copy-4",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -139,
    y1: -126,
    x2: 125.002916,
    y2: 346.352281,
    id: "Line-2-Copy-5",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -129,
    y1: -126,
    x2: 135.002916,
    y2: 346.352281,
    id: "Line-2-Copy-6",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -119,
    y1: -126,
    x2: 145.002916,
    y2: 346.352281,
    id: "Line-2-Copy-7",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -109,
    y1: -126,
    x2: 155.002916,
    y2: 346.352281,
    id: "Line-2-Copy-8",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -99,
    y1: -126,
    x2: 165.002916,
    y2: 346.352281,
    id: "Line-2-Copy-9",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -89,
    y1: -126,
    x2: 175.002916,
    y2: 346.352281,
    id: "Line-2-Copy-10",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -79,
    y1: -126,
    x2: 185.002916,
    y2: 346.352281,
    id: "Line-2-Copy-11",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -69,
    y1: -126,
    x2: 195.002916,
    y2: 346.352281,
    id: "Line-2-Copy-12",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -59,
    y1: -126,
    x2: 205.002916,
    y2: 346.352281,
    id: "Line-2-Copy-13",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -49,
    y1: -126,
    x2: 215.002916,
    y2: 346.352281,
    id: "Line-2-Copy-14",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -39,
    y1: -126,
    x2: 225.002916,
    y2: 346.352281,
    id: "Line-2-Copy-15",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -29,
    y1: -126,
    x2: 235.002916,
    y2: 346.352281,
    id: "Line-2-Copy-16",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -19,
    y1: -126,
    x2: 245.002916,
    y2: 346.352281,
    id: "Line-2-Copy-17",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -9,
    y1: -126,
    x2: 255.002916,
    y2: 346.352281,
    id: "Line-2-Copy-18",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -126,
    x2: 265.002916,
    y2: 346.352281,
    id: "Line-2-Copy-19",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: -126,
    x2: 275.002916,
    y2: 346.352281,
    id: "Line-2-Copy-20",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: -126,
    x2: 285.002916,
    y2: 346.352281,
    id: "Line-2-Copy-21",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31,
    y1: -126,
    x2: 295.002916,
    y2: 346.352281,
    id: "Line-2-Copy-22",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: -126,
    x2: 305.002916,
    y2: 346.352281,
    id: "Line-2-Copy-23",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51,
    y1: -126,
    x2: 315.002916,
    y2: 346.352281,
    id: "Line-2-Copy-24",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61,
    y1: -126,
    x2: 325.002916,
    y2: 346.352281,
    id: "Line-2-Copy-25",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71,
    y1: -126,
    x2: 335.002916,
    y2: 346.352281,
    id: "Line-2-Copy-26",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: -126,
    x2: 345.002916,
    y2: 346.352281,
    id: "Line-2-Copy-27",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91,
    y1: -126,
    x2: 355.002916,
    y2: 346.352281,
    id: "Line-2-Copy-28",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101,
    y1: -126,
    x2: 365.002916,
    y2: 346.352281,
    id: "Line-2-Copy-29",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111,
    y1: -126,
    x2: 375.002916,
    y2: 346.352281,
    id: "Line-2-Copy-30",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121,
    y1: -126,
    x2: 385.002916,
    y2: 346.352281,
    id: "Line-2-Copy-31",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131,
    y1: -126,
    x2: 395.002916,
    y2: 346.352281,
    id: "Line-2-Copy-32",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#question)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default ForwardRef;